export default {
  tabs: {
    online_shop: 'Online Shop',
    reservations: 'Reservations',
    storefront: 'Storefront',
  },
};
